export default __webpack_public_path__ + "static/media/SUPERINTENDENCIA.5a5ddb2e.jpeg";